document.addEventListener("DOMContentLoaded", function () {
  const SELECTOR_ITEM = ".product_stitching_item_card";
  const SELECTOR_CARD = ".product-card-link";
  const SELECTOR_NEW_CARD = "main .product-card-link";
  const productCardCache = new Map();
  const preloadPromises = new Map(); // Track ongoing preloads to avoid duplicates

  /**
   * @param {string} handle
   * @param {boolean} [isPreload=false] - Whether this is a preload request
   */
  async function fetchProductCard(handle, isPreload = false) {
    if (productCardCache.has(handle)) {
      if (!isPreload) {
        //console.log(`[Product Card] Using cached card for: ${handle}`);
      }
      return productCardCache.get(handle);
    }

    // If already preloading, wait for that promise
    if (preloadPromises.has(handle)) {
      if (!isPreload) {
        //console.log(`[Product Card] Waiting for ongoing preload: ${handle}`);
      }
      return preloadPromises.get(handle);
    }

    const url = `${handle}?view=product-card-template`;
    if (isPreload) {
      //console.log(`[Product Card] Starting preload: ${handle}`);
    } else {
      //console.log(`[Product Card] Fetching: ${handle}`);
    }

    const fetchPromise = fetch(url)
      .then((response) => response.text())
      .then((html) => {
        productCardCache.set(handle, html);
        preloadPromises.delete(handle);
        if (isPreload) {
          //console.log(`[Product Card] ✓ Preloaded successfully: ${handle}`);
        } else {
          //console.log(`[Product Card] ✓ Fetched successfully: ${handle}`);
        }
        return html;
      })
      .catch((err) => {
        preloadPromises.delete(handle);
        if (isPreload) {
          console.error(`[Product Card] ✗ Preload failed: ${handle}`, err);
        } else {
          console.error(`[Product Card] ✗ Fetch failed: ${handle}`, err);
        }
        throw err;
      });

    preloadPromises.set(handle, fetchPromise);
    return fetchPromise;
  }

  /**
   * Preloads product cards for all visible swatches
   */
  function preloadProductCards() {
    const items = document.querySelectorAll(SELECTOR_ITEM);
    const handles = new Set();

    items.forEach((item) => {
      const handle = /** @type {HTMLElement} */ (item).dataset.productHandle;
      if (handle && !productCardCache.has(handle)) {
        handles.add(handle);
      }
    });

    // Preload all handles, but limit concurrent requests to avoid overwhelming the server
    const handlesArray = Array.from(handles);
    const batchSize = 3; // Load 3 at a time
    const delayBetweenBatches = 100; // 100ms delay between batches

    //console.log(`[Product Card] Starting preload for ${handlesArray.length} product cards (in batches of ${batchSize})`);

    handlesArray.forEach((handle, index) => {
      const batchIndex = Math.floor(index / batchSize);
      setTimeout(() => {
        fetchProductCard(handle, true).catch((err) => {
          // Error already logged in fetchProductCard
        });
      }, batchIndex * delayBetweenBatches);
    });
  }

  /**
   * Preloads product card on hover for better UX
   */
  function setupHoverPreload() {
    document.body.addEventListener("pointerenter", (event) => {
      if (!(event.target instanceof Element)) return;
      const item = event.target.closest(SELECTOR_ITEM);
      if (!item) return;

      const productHandle = /** @type {HTMLElement} */ (item).dataset.productHandle;
      if (productHandle && !productCardCache.has(productHandle)) {
        //console.log(`[Product Card] Hover preload triggered: ${productHandle}`);
        // Preload on hover with low priority
        fetchProductCard(productHandle, true).catch(() => {
          // Error already logged in fetchProductCard
        });
      }
    }, true); // Use capture phase to catch events early
  }

  // Preload all product cards on page load
  preloadProductCards();

  // Also preload on hover for immediate feedback
  setupHoverPreload();

  // Handle clicks
  document.body.addEventListener("click", async (event) => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest(SELECTOR_ITEM);
    if (!item) return;

    event.preventDefault();

    const productHandle = /** @type {HTMLElement} */ (item).dataset.productHandle;
    const card = item.closest(SELECTOR_CARD);
    if (!card || !productHandle) return;

    const isCached = productCardCache.has(productHandle);
    //console.log(`[Product Card] Click detected: ${productHandle} ${isCached ? '(cached - instant update!)' : '(not cached - fetching...)'}`);

    try {
      const html = await fetchProductCard(productHandle);
      const temp = document.createElement("div");
      temp.innerHTML = html;
      const newCard = temp.querySelector(SELECTOR_NEW_CARD);

      if (newCard) {
        card.replaceWith(newCard);
        //console.log(`[Product Card] ✓ Card updated: ${productHandle}`);
      } else {
        //console.warn(`[Product Card] ⚠ Could not find new card element for: ${productHandle}`);
      }
    } catch (err) {
      //console.error(`[Product Card] ✗ Error updating product card: ${productHandle}`, err);
    }
  });
});
